import { InitConfig, InteractionMessage } from '@solidgate/react-sdk';

export type PaymentFormParams = Omit<InitConfig, 'merchantData'>;

export enum PaymentFormType {
  SUBSCRIPTION = 'SUBSCRIPTION',
  UPSELL = 'UPSELL',
}

export enum PaymentMethodsVariant {
  TABS = 'TABS',
  STACKED = 'STACKED',
}

export enum PixVariant {
  AUTOMATICO = 'AUTOMATICO',
  QR = 'QR',
}

export type PaymentInteraction = InteractionMessage;
